import {template as tpl, viewModel as SearchViewModel} from "./search";
import {IRouteDefinitionParams, IRuleset} from "../../index";
import {global} from "../../appContext";
import {getChildHash} from "../../constants/RouteDefinitions";
import {ISelectedListActions} from "../object/selected-list";
import {nsClone} from "../../clone/fn";

export const template = tpl

export class viewModel<T = IRuleset> extends SearchViewModel {
    constructor(params: IRouteDefinitionParams) {
        super(params);
        this.TABLE.unshift({key: 'selector'})
    }

    protected override onRowClick(item: any, e: JQuery.Event) {
        if (this.selectedObjects().length) {
            const hash = getChildHash(this.__routeDef, {id: item.id});
            window.open(hash, '_blank');
            return
        }
        return super.onRowClick(item, e)
    }

    protected override getValue = (key: keyof T, item: T): any => {
        const cellContent = this.getCellContent({item: item, key: key, mark: false});
        if (cellContent) {
            return cellContent
        } else {
            return item[String(key).toLowerCase() as keyof T]
        }
    }

    protected override getSelectedListActions(): ISelectedListActions {
        return {
            quickActions: [{
                label: 'Copy',
                onClick: () => nsClone.dialogCopyFromSearch(
                    `copy subject|s:((ruleset|ac|n:${this.numAffectedObjects()}))`,
                    "component/ruleset/copy-wizard/main",
                    this.selectedObjects(),
                    this.getParams(),
                ),
                validator: () => global.permissionValidator.isMinCompanyAdmin(),
            }],
            moreActions: [{
                label: 'Delete',
                onClick: () => global.dialogManager.addComponent({
                    content: {
                        name: 'component/ruleset/dialog/multi-delete',
                        params: {selectedObjects: this.selectedObjects(), requestParams: this.getParams()}
                    },
                    title: `delete subject|s:((ruleset|ac|n:${this.numAffectedObjects()}))`
                }),
                validator: () => global.permissionValidator.isMinCompanyAdmin(),
            }],
        }
    }

}
